@for (radioButton of radioButtons; track $index) {
  <label class="radio-button"
          [ngClass]="getRadioButtonClasses(radioButton.value, $last)"
          [attr.for]="radioButton.id">
    <div class="radio-button__circle circle">
      <input class="radio-button__input input"
              type="radio"
              [id]="radioButton.id"
              [value]="radioButton.value"
              [disabled]="disabled"
              [attr.data-ideals]="'radio-buttons' + radioButton.id"
              [ngModel]="value"
              (ngModelChange)="modelChange(radioButton.value)"
              data-ideals="radio">
    </div>
    <span class="radio-button__label">{{radioButton.caption | translate}}</span>
  </label>
}
